import { render, staticRenderFns } from "./productTablePhone.vue?vue&type=template&id=5ca659c8&scoped=true"
import script from "./productTablePhone.vue?vue&type=script&lang=js"
export * from "./productTablePhone.vue?vue&type=script&lang=js"
import style1 from "./productTablePhone.vue?vue&type=style&index=1&id=5ca659c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca659c8",
  null
  
)

export default component.exports